import { http } from "../../../common/helpers/index";
import { baseUrl } from "../../../common/config";

export const updateAvatarProfile = (data) => {
  return http.patch(`${baseUrl}/api/participant/profile-image`, data);
};
